var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteImageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FDE8E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 15.17H17.5C17.5687 15.17 17.625 15.1115 17.625 15.04V15.17ZM17.625 15.17H22.375V15.04C22.375 15.1115 22.4312 15.17 22.5 15.17H22.375V16.34H23.5V15.04C23.5 14.4664 23.0516 14 22.5 14H17.5C16.9484 14 16.5 14.4664 16.5 15.04V16.34H17.625V15.17ZM25.5 16.34H14.5C14.2234 16.34 14 16.5724 14 16.86V17.38C14 17.4515 14.0562 17.51 14.125 17.51H15.0687L15.4547 26.0087C15.4797 26.5629 15.9203 27 16.4531 27H23.5469C24.0813 27 24.5203 26.5645 24.5453 26.0087L24.9312 17.51H25.875C25.9438 17.51 26 17.4515 26 17.38V16.86C26 16.5724 25.7766 16.34 25.5 16.34ZM23.4266 25.83H16.5734L16.1953 17.51H23.8047L23.4266 25.83Z",
    fill: "#C7120F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteImageIcon);
export default __webpack_public_path__ + "static/media/delete-image-icon.5f5384252abb0d84ac37500d36bda363.svg";
export { ForwardRef as ReactComponent };